import { fetchApi } from 'api/fetchApi'
import { paths as notifications_pushes } from 'api/generated/notifications_pushes'

export const fetchPushNotificationsApi = (headers) =>
  fetchApi<
    notifications_pushes['/notifications/subscriptions']['get']['responses']['200']['schema']
  >('/notifications/subscriptions', {
    headers,
  })
